// extracted by mini-css-extract-plugin
export default {"basic":"button_basic__z6xna","bigger":"button_bigger__6K1z2","smaller":"button_smaller__oHTWP","blue":"button_blue__KTXVE","white":"button_white__A6rMA"};